module.exports = __webpack_public_path__ + "r-v3/img/ico_blur_video_white.4e0b863d.svg";